import Message from 'shared_components/message';
import { axiosLabAPI } from 'services/axios';
import { API_GET_METHOD, API_POST_METHOD, API_PUT_METHOD } from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';

export async function fetchLabAnalizer() {
	let LabAnalizer = [];

	try {
		const content = {
			method: API_GET_METHOD,
			url: 'settings/labanalyzer',
		};
		const response = await axiosLabAPI(content);
		const { data } = await response;

		LabAnalizer = data.RECORDS;
	} catch (e) {
		showMessage(e);
	}

	return LabAnalizer;
}
